module.exports = {
    // 根据groupPostion解析按钮列表
    getBtnList : function (btnList){
        
        if(typeof(btnList) === "string") {
            btnList = JSON.parse(btnList)
        }

        let  generalArea = []
        let listArea = []
        for(let i in btnList){
            if(btnList[i].groupPosition === 1){
                generalArea.push(btnList[i])
            } else if(btnList[i].groupPosition === 2){
                listArea.push(btnList[i])
            }
        }
        return {
            generalArea : generalArea,
            listArea : listArea
        }
    }
}
  


// WEBPACK FOOTER //
// ./src/com/common.js